/**
 * 🚨 DEVELOPMENT ONLY - MOCK API RESPONSES 🚨
 *
 * Set USE_MOCK_API = true to bypass real API calls
 * Capture real data from production and paste here
 */

import { BASEURL, QUICKPAYURL } from "../../environments/environment";

// Set to false to use real backend APIs (requires CORS access or same domain)
// Set to true to use mock data for local development (recommended for localhost)
// Note: S3 bucket doesn't have CORS enabled for localhost, so mock mode is needed
export const USE_MOCK_API = false;

// ============ PERSONAL DETAILS ============
export const MOCK_PERSONAL_DETAILS = {
  CustomerId: "acb2eb4e-8b6c-42bf-b290-ed3d03fa4f16",
  MambuId: "170611333",
  Gender: "Male",
  FirstName: "Praveen",
  MiddleName: null,
  LastName: "Kumar",
  PinCode: "201301",
  City: "Gautam Buddha Nagar",
  Email: "test@example.com",
  MobileNumber: "9999999999",
};

// ============ CREDIT LIMIT ============
export const MOCK_CREDIT_LIMIT = {
  Status: "Active",
  CreditLimit: 50000,
  AvailableLimit: 35000,
  UsedLimit: 15000,
  ExpiryDate: "2027-01-28",
};

// ============ LOANS ============
export const MOCK_ACTIVE_LOANS = [
  {
    LoanId: "loan-001",
    MerchantName: "Amazon",
    ProductName: "Electronics",
    LoanAmount: 10000,
    EMIAmount: 1000,
    RemainingEMIs: 8,
    TotalEMIs: 12,
    Status: "Active",
  },
];

export const MOCK_PAST_LOANS = [
  {
    LoanId: "loan-002",
    MerchantName: "Flipkart",
    ProductName: "Mobile Phone",
    LoanAmount: 15000,
    Status: "Closed",
  },
];

// ============ GC MERCHANTS - Exact data from merchant bucket ============
export const MOCK_GC_MERCHANTS = {
  merchants: {
    Flipkart: {
      name: "Flipkart",
      photoUrl:
        "https://assets.zestmoney.in/assets/merchant-logos/Flipkart.png",
      websiteUrl:
        `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=flipkart`,
      dashboard_websiteUrl:
        `${BASEURL}/emi/flipkart-product`,
      merchantId: "d1131025-65ba-40ed-90c3-92841e06314b",
      checkWhiteListing: true,
      isAbsolute: false,
    },
    AmazonPay: {
      name: "AmazonPay",
      photoUrl:
        "https://assets.zestmoney.in/assets/merchant-logos/Amazon%20pay.png",
      websiteUrl:
        `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=amazonpay`,
      dashboard_websiteUrl:
        `${BASEURL}/emi/amazon-product`,
      merchantId: "d6eb9c55-6690-4525-987c-655a1be59083",
      checkWhiteListing: true,
      isAbsolute: false,
    },
    Yatra: {
      name: "Yatra",
      photoUrl: "https://assets.zestmoney.in/assets/merchant-logos/Yatra.png",
      websiteUrl:
        "https://www.zestmoney.in/partner/emi-for-everything-on-yatra/",
      dashboard_websiteUrl:
        "https://www.zestmoney.in/partner/emi-for-everything-on-yatra/",
      merchantId: "",
      checkWhiteListing: false,
      isAbsolute: true,
    },
    MakeMyTrip: {
      name: "MakeMyTrip",
      photoUrl:
        "https://assets.zestmoney.in/assets/merchant-logos/Make%20my%20trip.png",
      websiteUrl: "https://www.zestmoney.in/partner/makemytrip/#how-it-works",
      dashboard_websiteUrl:
        "https://www.zestmoney.in/partner/makemytrip/#how-it-works",
      merchantId: "5b619985-570b-42f6-93ec-b4c1279c86a6",
      checkWhiteListing: false,
      isAbsolute: true,
    },
    Myntra: {
      name: "Myntra",
      photoUrl: "https://assets.zestmoney.in/assets/merchant-logos/myntra.png",
      websiteUrl:
        `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=myntra`,
      dashboard_websiteUrl: "https://zestmoney.in/myntra/",
      merchantId: "39b74682-334e-462c-8cd3-e67d48b01273",
      checkWhiteListing: false,
      isAbsolute: false,
    },
    Mi: {
      name: "Mi",
      photoUrl: "https://assets.zestmoney.in/assets/merchant-logos/Xiomi.png",
      websiteUrl: "https://www.mi.com/in/",
      dashboard_websiteUrl: "https://www.mi.com/in/",
      checkWhiteListing: false,
      merchantId: "",
      isAbsolute: true,
    },
    Decathlon: {
      name: "Decathlon",
      photoUrl:
        "https://assets.zestmoney.in/assets/merchant-logos/Decathlon.png",
      websiteUrl: "https://www.decathlon.in",
      dashboard_websiteUrl: "https://www.decathlon.in",
      merchantId: "",
      checkWhiteListing: false,
      isAbsolute: true,
    },
    HappyEasyGo: {
      name: "HappyEasyGo",
      photoUrl:
        "https://assets.zestmoney.in/assets/merchant-logos/HappyEasyGo.png",
      websiteUrl: "https://www.happyeasygo.com/",
      dashboard_websiteUrl: "https://www.happyeasygo.com/",
      merchantId: "",
      checkWhiteListing: false,
      isAbsolute: true,
    },
    Flomattress: {
      name: "Flomattress",
      photoUrl: "https://assets.zestmoney.in/assets/merchant-logos/Flo.png",
      websiteUrl: "https://www.flomattress.com",
      dashboard_websiteUrl: "https://www.flomattress.com",
      merchantId: "",
      checkWhiteListing: false,
      isAbsolute: true,
    },
    Sangeetha: {
      name: "Sangeetha",
      photoUrl:
        "https://assets.zestmoney.in/assets/merchant-logos/Sangeetha.png",
      websiteUrl: "https://www.sangeethamobiles.com/",
      dashboard_websiteUrl: "https://www.sangeethamobiles.com/",
      merchantId: "",
      checkWhiteListing: false,
      isAbsolute: true,
    },
    "Forever New": {
      name: "Forever New",
      photoUrl:
        "https://assets.zestmoney.in/assets/merchant-logos/Forever%20new.png",
      websiteUrl: "http://forevernew.co.in",
      dashboard_websiteUrl: "http://forevernew.co.in",
      merchantId: "",
      checkWhiteListing: false,
      isAbsolute: true,
    },
    Lifestyle: {
      name: "Lifestyle",
      photoUrl:
        "https://assets.zestmoney.in/assets/merchant-logos/Lifestyle.png",
      websiteUrl:
        `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=lifestyle`,
      dashboard_websiteUrl: `${BASEURL}/stores/lifestyle`,
      merchantId: "e9ef9a89-6ce6-4c0e-a497-dcabd5904f88",
      checkWhiteListing: false,
      isAbsolute: false,
    },
    Titan: {
      name: "Titan",
      photoUrl: "https://assets.zestmoney.in/assets/merchant-logos/Titan.png",
      websiteUrl:
        `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=titan`,
      dashboard_websiteUrl: `${BASEURL}/stores/titan`,
      merchantId: "e44651fd-e19e-4f05-92e0-38c58aa40dd9",
      checkWhiteListing: false,
      isAbsolute: false,
    },
    Helios: {
      name: "Helios",
      photoUrl:
        "https://assets.zestmoney.in/assets/merchant-logos/HeliosbyTitan.png",
      websiteUrl:
        `${BASEURL}/emi/get?utm_source=myaccounts&utm_medium=CL&utm_campaign=helios`,
      dashboard_websiteUrl: `${BASEURL}/stores/helios`,
      merchantId: "800bd9fe-762d-46cd-857e-d1189845d57e",
      checkWhiteListing: false,
      isAbsolute: false,
    },
  },
  giftCardMerchants: [],
};

// ============ FAQS - Credit Limit FAQs ============
export const MOCK_CREDIT_LIMIT_FAQS = {
  approve: [
    {
      question: "What is a credit limit?",
      answer:
        "A credit limit is the maximum amount of credit that ZestMoney will extend to you.",
      isActive: false,
    },
    {
      question: "How is my credit limit determined?",
      answer:
        "Your credit limit is determined based on your credit history, income, and other factors.",
      isActive: false,
    },
    {
      question: "How can I increase my credit limit?",
      answer:
        "You can increase your credit limit by making timely payments and maintaining a good credit score.",
      isActive: false,
    },
  ],
};

// ============ CREDIT BALANCE SCREENS API RESPONSE ============
export const MOCK_CREDIT_BALANCE_SCREENS = {
  sections: [
    {
      title: "Available Credit Limit",
      data: [
        {
          title: "₹35,000",
          tag: {
            fontColor: "033418",
          },
        },
      ],
      icon: {
        imageUrl:
          "https://assets.zestmoney.in/assets/customers/credit_balance/info_icon.svg",
      },
      tag: {
        text: "Active",
        backgroundColor: "E2F7EB",
        fontColor: "07893F",
      },
    },
    {
      title: "Pay your EMIs on time to maintain your credit limit",
      imageUrl:
        "https://assets.zestmoney.in/assets/customers/credit_balance/credit_limit_info.svg",
      buttons: null,
    },
  ],
};

// ============ KNOW COMMON REASONS API RESPONSE ============
export const MOCK_KNOW_COMMON_REASONS = {
  sections: [
    {
      title: "Possible reasons for not getting approved",
      data: [
        {
          title: "Low Credit Score",
          subtitle: "Your credit score might be lower than required",
          imageUrl:
            "https://assets.zestmoney.in/assets/customers/credit_balance/credit%20score.svg",
        },
        {
          title: "Income",
          subtitle: "Your income might not meet the minimum requirement",
          imageUrl:
            "https://assets.zestmoney.in/assets/customers/credit_balance/Income.svg",
        },
        {
          title: "Credit History",
          subtitle: "You may have inconsistent payment history",
          imageUrl:
            "https://assets.zestmoney.in/assets/customers/credit_balance/Credit%20history.svg",
        },
        {
          title: "Age",
          subtitle: "Age requirements may not be met",
          imageUrl:
            "https://assets.zestmoney.in/assets/customers/credit_balance/Age.svg",
        },
        {
          title: "Documents",
          subtitle: "Some documents might be missing or invalid",
          imageUrl:
            "https://assets.zestmoney.in/assets/customers/credit_balance/documents.svg",
        },
      ],
    },
  ],
};

// ============ LEFT PANEL FLAGS ============
export const MOCK_LEFT_PANEL_FLAGS = {
  customerHasActiveOrArrearLoanOrApprovedGiftVoucherLoan: true,
  customerHasActiveOrApprovedOrUtilizedCreditLimit: true,
  customerHasPersonalLoanEligibility: false,
  customerHasReferralEligibility: false,
  experianSwitch: true,
  personalDetails: MOCK_PERSONAL_DETAILS,
};

// ============ SWITCH CONFIGS ============
export const MOCK_CL_REACTIVATION_SWITCH = {
  enabled: false,
};

export const MOCK_PL_BANNER_SWITCH = {
  PLBanner: true, // Enable to test PL banner
};

// Product listing toggle
export const MOCK_PRODUCT_LISTING_TOGGLE = {
  enabled: true, // Enable to show products
};

export const MOCK_HOME_BANNER_SWITCH = {
  enabled: false,
};

// ============ PROFILE PHOTO ============
export const MOCK_PROFILE_PHOTO: any[] = [];

export const MOCK_PHOTO_API = {
  url: "",
};

// ============ RECOMMENDED PRODUCTS ============
// Using placeholder images that always load - replace with real API data when connected to backend
export const MOCK_RECOMMENDED_PRODUCTS = {
  sections: [
    {
      data: [
        {
          title: "iPhone 15",
          subtitle: "Starting at ₹1,999/mo",
          imageUrl: "https://picsum.photos/seed/iphone/150/150",
          ranking: 1,
          price: 79999,
          action: {
            data: {
              deeplinkUrl: "https://www.amazon.in/iphone",
            },
          },
        },
        {
          title: "Samsung TV",
          subtitle: "No cost EMI",
          imageUrl: "https://picsum.photos/seed/tv/150/150",
          ranking: 2,
          price: 45999,
          action: {
            data: {
              deeplinkUrl: "https://www.flipkart.com/tv",
            },
          },
        },
        {
          title: "MacBook Air",
          subtitle: "Starting at ₹4,999/mo",
          imageUrl: "https://picsum.photos/seed/macbook/150/150",
          ranking: 3,
          price: 99999,
          action: {
            data: {
              deeplinkUrl: "https://www.amazon.in/macbook",
            },
          },
        },
        {
          title: "Sony Headphones",
          subtitle: "0% Interest",
          imageUrl: "https://picsum.photos/seed/headphones/150/150",
          ranking: 4,
          price: 24999,
          action: {
            data: {
              deeplinkUrl: "https://www.croma.com/headphones",
            },
          },
        },
        {
          title: "iPad Pro",
          subtitle: "Starting at ₹3,499/mo",
          imageUrl: "https://picsum.photos/seed/ipad/150/150",
          ranking: 5,
          price: 89999,
          action: {
            data: {
              deeplinkUrl: "https://www.amazon.in/ipad",
            },
          },
        },
        {
          title: "Washing Machine",
          subtitle: "Easy EMI",
          imageUrl: "https://picsum.photos/seed/washing/150/150",
          ranking: 6,
          price: 35999,
          action: {
            data: {
              deeplinkUrl: "https://www.flipkart.com/washing",
            },
          },
        },
        {
          title: "Air Conditioner",
          subtitle: "Summer Offer",
          imageUrl: "https://picsum.photos/seed/ac/150/150",
          ranking: 7,
          price: 42999,
          action: {
            data: {
              deeplinkUrl: "https://www.croma.com/ac",
            },
          },
        },
        {
          title: "Camera",
          subtitle: "0% Processing Fee",
          imageUrl: "https://picsum.photos/seed/camera/150/150",
          ranking: 8,
          price: 65999,
          action: {
            data: {
              deeplinkUrl: "https://www.amazon.in/camera",
            },
          },
        },
      ],
    },
  ],
};

// ============ PERSONAL LOAN BANNER STATUS ============
export const MOCK_PL_BANNER_STATUS = {
  sections: [
    {
      type: "introBanner",
    },
  ],
};

// ============ PERSONAL LOAN BANNER CONTENT ============
export const MOCK_PL_BANNER_CONTENT = {
  sections: [
    {
      title: "Get instant cash up to ₹5 Lakhs",
      subtitle: "Flexible EMI options available",
      buttons: [
        {
          label: "See Plans",
          actionUrl:
            `${QUICKPAYURL}/personal-loan?token=<token>`,
        },
      ],
      aidSideText: "View Details",
      imageUrl:
        "https://assets.zestmoney.in/assets/personal-loan/pl-status.png",
    },
  ],
};

// ============ RISK CHECK RESPONSE ============
export const MOCK_RISK_CHECK = {
  credit_limit: {
    available_amt: 35000,
    expires_on: "2027-01-28T00:00:00Z",
  },
  status_code: "ZMRSK200",
  comms_code: 0,
};

// ============ HELPER TO GET MOCK RESPONSE ============
export const getMockResponse = (endpoint: string): any => {
  const mocks: Record<string, any> = {
    // Personal Details
    "/customers/personal-details": MOCK_PERSONAL_DETAILS,
    "/PersonalDetails": MOCK_PERSONAL_DETAILS,

    // Credit Limit & Risk
    "/credit-limit": MOCK_CREDIT_LIMIT,
    "/risk/riskCheck": MOCK_RISK_CHECK,

    // Loans
    "/loans/active": MOCK_ACTIVE_LOANS,
    "/loans/past": MOCK_PAST_LOANS,
    "/loans": { active: MOCK_ACTIVE_LOANS, past: MOCK_PAST_LOANS },
    "/Loan/Customer": MOCK_ACTIVE_LOANS,

    // Merchants
    "/my_accounts_merchants/credit_balance_merchants.json": MOCK_GC_MERCHANTS,
    "/api/merchants/gc-merchants": MOCK_GC_MERCHANTS,

    // FAQs
    "/api/faqs/credit-limit": MOCK_CREDIT_LIMIT_FAQS,
    "/faqs": MOCK_CREDIT_LIMIT_FAQS,

    // Left panel
    "/left-panel": MOCK_LEFT_PANEL_FLAGS,

    // Switch configs
    "/switch/CLReactivationSwitch.json": MOCK_CL_REACTIVATION_SWITCH,
    "/switch/cl_reactivation.json": MOCK_CL_REACTIVATION_SWITCH,
    "/switch/PLBannerSwitch.json": MOCK_PL_BANNER_SWITCH,
    "/switch/product_listing_toggle.json": MOCK_PRODUCT_LISTING_TOGGLE,
    "/switch/RecommendedProductSwitch.json": MOCK_PRODUCT_LISTING_TOGGLE,
    "/switch/home_banner.json": MOCK_HOME_BANNER_SWITCH,

    // Documents and Photos
    "/documentCategory/Photo/document": MOCK_PROFILE_PHOTO,
    "/photo?customerId": MOCK_PHOTO_API,

    // Recommended products
    "/screens/product-recommendations-screens": MOCK_RECOMMENDED_PRODUCTS,
    "/api/merchants/recommended-products": MOCK_RECOMMENDED_PRODUCTS,

    // Credit Balance Screens API
    "/screens/credit-balance-screens": MOCK_CREDIT_BALANCE_SCREENS,

    // Know Common Reasons API
    "/screens/know-common-reasons-screens": MOCK_KNOW_COMMON_REASONS,

    // Personal Loan Banner
    "/redemption/customers": MOCK_PL_BANNER_STATUS,
    "/screens/personal-loan-screens": MOCK_PL_BANNER_CONTENT,
  };

  // Find matching endpoint
  for (const key of Object.keys(mocks)) {
    if (endpoint.includes(key)) {
      console.log(`🔶 MOCK API: ${endpoint}`);
      return mocks[key];
    }
  }

  console.warn(`⚠️ No mock for: ${endpoint}`);
  return null;
};
